(function($) {
	'use strict';

	/**
	 * Extract all CRF mappings from data and control sets
	 * 
	 * This function processes control sets and extracts CRF mappings for each
	 * control UID within each standard. It creates a comprehensive mapping
	 * structure for CRF data processing.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {Object} controlSets - Object containing control sets organized by standard
	 * @returns {Object} Object containing CRF mappings organized by standard and control UID
	 */
	function extractAllCRFMappings(data, controlSets) {
		const mappings = {};
		Object.entries(controlSets).forEach(([key, uids]) => {
			mappings[key] = {};
			uids.forEach(uid => {
				mappings[key][uid] = WebAssessmentCharts.extractCRFMapping(data, uid);
			});
		});
		return mappings;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractAllCRFMappings };
	} else if (typeof window !== 'undefined') {
		window.extractAllCRFMappings = extractAllCRFMappings;
	}

})(jQuery);
